import React, { useState, useEffect } from "react";
import Sidebar from "../profile-sidebar/profileSidebar";
import Edit from "./edit";
import Delete from "./delete";
import Modal from "react-bootstrap/Modal";
const Review = () => {
  const [showModal, setShowModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  //prevent default a tag in review page
  useEffect(() => {
    const handleClick = (e) => {
      if (e.target.tagName === "A" && e.target.getAttribute("href") === "#") {
        e.preventDefault();
      }
    };

    document.addEventListener("click", handleClick);

    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, []);

  return (
    <div className="content">
      <div className="container">
        <div className="row">
          {/* <!-- Sidebar --> */}
          <Sidebar page="review" />
          {/* <!-- /Sidebar --> */}

          <div className="col-xl-9 col-lg-8">
            {/* <!-- Review Title --> */}
            <div className="card">
              <div className="card-body">
                <div className="d-flex justify-content-between align-items-center flex-wrap">
                  <div>
                    <h6>My Reviews</h6>
                    <p className="fs-14">No of Reviews : 60</p>
                  </div>
                </div>
              </div>
            </div>
            {/* <!-- /Review Title --> */}

            {/* <!-- Reviews --> */}
            <div className="card shadow-none">
              <div className="card-body">
                <div className="border-bottom mb-3">
                  <div className="d-flex justify-content-between align-items-center flex-wrap row-gap-2 mb-2">
                    <div className="d-flex align-items-center">
                      <span className="avatar avatar-lg rounded-circle flex-shrink-0 me-2">
                        <img
                          src="assets/img/users/user-01.jpg"
                          alt="user"
                          className="img-fluid rounded-circle"
                        />
                      </span>
                      <div>
                        <h6 className="fs-16">Jeffrey Wilson</h6>
                        <div className="d-flex align-items-center flex-wrap">
                          <span className="fs-14 d-flex align-items-center">
                            2 days ago
                            <i className="ti ti-point-filled text-gray mx-2"></i>
                          </span>
                          <p className="fs-14">
                            <span className="badge badge-xs badge-warning text-gray-9 me-2">
                              4.0
                            </span>
                            Excellent service!
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="d-flex align-items-center">
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          setShowModal(true);
                        }}
                        className="btn btn-white btn-sm border me-2"
                        data-bs-toggle="modal"
                        data-bs-target="#edit_review"
                      >
                        <i className="isax isax-edit-2 me-1"></i>Edit
                      </a>
                      <a
                        href="#"
                        className="btn btn-white btn-sm border"
                        data-bs-toggle="modal"
                        data-bs-target="#delete_modal"
                        onClick={(e) => {
                          e.preventDefault();
                          setShowDeleteModal(true);
                        }}
                      >
                        <i className="isax isax-trash me-1"></i>Delete
                      </a>
                    </div>
                  </div>
                  <p className="fs-16 mb-3">
                    It was a good location however the cocoon concept was weird.
                    No tables, chairs etc was difficult as everything went on
                    the floor.
                  </p>
                </div>
                <div className="d-flex justify-content-between align-items-center flex-wrap row-gap-2">
                  <p className="fs-14 d-flex align-items-center mb-0">
                    <i className="isax isax-info-circle5 text-gray-9 me-2"></i>
                    Info : Hotel Booking (Hayat Hotel)
                  </p>
                  <div className="d-flex align-items-center">
                    <a href="#" className="fs-14 me-3">
                      <i className="isax isax-like-1 me-1"></i>21
                    </a>
                    <a href="#" className="fs-14 me-3">
                      <i className="isax isax-dislike me-1"></i>50
                    </a>
                    <a href="#" className="fs-14 ">
                      <i className="isax isax-heart5 text-danger me-1"></i>45
                    </a>
                  </div>
                </div>
              </div>
            </div>
            {/* <!-- /Reviews --> */}

            {/* <!-- Pagination --> */}
            <nav className="pagination-nav">
              <ul className="pagination justify-content-center justify-content-sm-end ">
                <li className="page-item disabled">
                  <a className="page-link" href="#" aria-label="Previous">
                    <span aria-hidden="true">
                      <i className="fa-solid fa-chevron-left"></i>
                    </span>
                  </a>
                </li>
                <li className="page-item">
                  <a className="page-link" href="#">
                    1
                  </a>
                </li>
                <li className="page-item">
                  <a className="page-link" href="#">
                    2
                  </a>
                </li>
                <li className="page-item">
                  <a className="page-link" href="#">
                    3
                  </a>
                </li>
                <li className="page-item active">
                  <a className="page-link" href="#">
                    4
                  </a>
                </li>
                <li className="page-item">
                  <a className="page-link" href="#">
                    5
                  </a>
                </li>
                <li className="page-item">
                  <a className="page-link" href="#" aria-label="Next">
                    <span aria-hidden="true">
                      <i className="fa-solid fa-chevron-right"></i>
                    </span>
                  </a>
                </li>
              </ul>
            </nav>
            {/* <!-- /Pagination --> */}
          </div>
          {/* <Edit showModal={showModal} setShowModal={setShowModal} />
          <Delete
            showModal={showDeleteModal}
            setShowModal={setShowDeleteModal}
          /> */}
        </div>
      </div>
    </div>
  );
};

export default Review;
